import { action, computed, observable } from 'mobx';
import { ObjectFormField } from './ObjectFormField';
import { FormFields } from './PrimitiveFormField';
import { Nullable, Readonly } from './Types';

export class FormStore<T> {
    public constructor(initialValues: Nullable<T>) {
        this.formField = new ObjectFormField('', initialValues);
    }

    public validate() {
        return this.formField.validate();
    }

    @computed
    public get fields(): FormFields<T> {
        return this.formField.fields;
    }

    @computed
    public get values(): Readonly<T> {
        return this.formField.value;
    }

    @action
    public addErrors(errors: { [key: string]: string[] }) {
        console.debug('FormStore errors', errors);

        this.formField.addErrors(errors);

        if (errors.global) errors.global.forEach(e => this.globalErrors.push(e));
    }

    @action
    public addGlobalError(error: any) {
        console.error('Global error ' + error.message);
        this.globalErrors.push('' + error.message); // Force to be a string
    }

    public clearGlobalErrors() {
        this.globalErrors.length = 0;
    }

    @action
    public apply(values: T) {
        this.formField.setValue(values);
    }

    @action
    public clear() {
        this.formField.clear();
        this.clearGlobalErrors();
    }

    @action
    public add<V>(key: string, value: V) {
        this.formField.add(key, value);
    }

    @action
    public remove(key: string) {
        this.formField.remove(key);
    }

    @action
    public onSubmit() {
        this.formField.onSubmit();
    }

    @observable
    public readonly globalErrors: string[] = [];

    private formField: ObjectFormField<T>;
}
